<script lang="tsx">

import {defineComponent, PropType} from "vue";

export const CaptionSizeKeys = ["Normal", "Small"]
export type CaptionSize = typeof CaptionSizeKeys[number]

export const CaptionColorKeys = ["Light", "Dark"]
export type CaptionColor = typeof CaptionColorKeys[number]


export default defineComponent({
  name: "Caption",
  props: {
    size: {
      type: String as PropType<CaptionSize>,
      default: "Normal"
    },
    color: {
      type: String as PropType<CaptionColor>,
      default: "Light"
    }
  },
  render() {
    return (
      <span class={`caption caption--${this.$props.size} caption--${this.$props.color}`}>
          {this.$slots.default?.()}
      </span>
    )
  }
})
</script>


<style lang="scss" scoped>
@import "src/css/common/index";

@include important {
  .caption {
    font-family: "SiemensSans", sans-serif;
    font-size: 16px;
    line-height: 28px;
    word-break: break-word;

    &--Small {
      font-size: 12px;
      line-height: 20px;
    }

    &--Dark {
     color: $color-input-3;
    }
  }
}
</style>


